// extracted by mini-css-extract-plugin
module.exports = {"tabContainer":"SegmentedButton__tabContainer","tabHeader":"SegmentedButton__tabHeader","navList":"SegmentedButton__navList","activeTabHeader":"SegmentedButton__activeTabHeader"};